import { IHttpApi } from '@cian/http-api/shared/http';

import { fetchAddFavorite, IAddFavoriteRequest } from '../../../repositories/favorites/v1/add-favorite';
import { assertUnknownError } from './assert';
import { mapAddFavoriteResponse, mapAddFavoriteResponseError } from './mappers';
import { IAddFavorite } from '../../../types/favorite';
import {
  EDealType,
  EEntityType,
} from '../../../repositories/favorites/entities/add_favorite/AddFavoriteEntityPublicRequestSchema';

export async function addFavoriteRequest({
  httpApi,
  parameters,
}: {
  httpApi: IHttpApi;
  parameters: Omit<IAddFavoriteRequest, 'dealType' | 'entityType'>;
}): Promise<IAddFavorite> {
  const response = await fetchAddFavorite({
    httpApi,
    parameters: {
      dealType: EDealType.Sale,
      entityType: EEntityType.OfferResidental,
      ...parameters,
    },
    mappers: {
      200: mapAddFavoriteResponse,
      400: mapAddFavoriteResponseError,
    },
  });

  assertUnknownError(response);

  return response.response as IAddFavorite;
}
